/* tslint:disable */
/* eslint-disable */
export enum DbrBalloonTypeEnum {
  $0 = 0,
  $1 = 1,
  $2 = 2
}
